import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "doughnut-chart-container" }
const _hoisted_2 = ["id"]

import DoughnutChartBaseWrapper from '../chartjs/DoughnutChartBaseWrapper.vue';
import { Data, DataFilter, LabelsAndData, Series } from '../../models';
import { chartDataUtil } from '../../util/ChartDataUtil';
import { useReportData } from '@/features/reports/util/useReportData';
import { computed, PropType } from 'vue';
import Report from '@/features/reports/components/Report.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TotalsDoughnutChart',
  props: {
  data: {
    type: Object as PropType<Data>,
    required: true,
  },
  loadedData: {
    type: Boolean,
    default: false,
  },
  loadingError: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  subTitle: {
    type: String,
    default: '',
  },
  dataFilter: {
    type: Object as PropType<DataFilter>,
  },
  series: {
    type: [Function, String] as PropType<((data: Data) => Series) | string>,
    required: true,
  },
  maxItems: {
    type: Number,
    default: 10,
  },
},
  setup(__props) {

const props = __props;

const { reportId, isDataLoaded, isDataEmpty } = useReportData(props);

const processedData = computed<LabelsAndData>(() => {
  const labelsAndData = { labels: props.data.scale.labels, data: seriesData.value.data };

  const filter = (label: string, value: number) => value > 0;
  const filteredData = chartDataUtil.filterData(labelsAndData, filter);

  const orderedData = chartDataUtil.orderData(filteredData, {
    dataOrderAscending: false,
    forceZeroValuesToBottom: false,
  });

  return chartDataUtil.restrictDataToTopX(orderedData, {
    maxItems: props.maxItems,
    groupNonDisplayedItemsIntoOther: true,
    otherItemsLabel: 'Others',
  });
});

const seriesData = computed<Series>(() => {
  if (typeof props.series === 'string') {
    return props.data.series.filter((series) => series.name === props.series)[0];
  } else {
    return props.series(props.data);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Report, {
    "report-id": _unref(reportId),
    title: __props.title,
    class: "chart-container",
    "data-empty": _unref(isDataEmpty),
    "loaded-data": _unref(isDataLoaded),
    "loading-error": __props.loadingError,
    "no-labels": ""
  }, {
    chart: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(DoughnutChartBaseWrapper, {
          title: __props.subTitle,
          class: "chart",
          "legend-element-id": 'legendContainer-' + _unref(reportId),
          "labels-and-data": processedData.value,
          dataFilter: __props.dataFilter,
          series: __props.series,
          "max-items": __props.maxItems
        }, null, 8, ["title", "legend-element-id", "labels-and-data", "dataFilter", "series", "max-items"])
      ]),
      _createElementVNode("div", {
        id: 'legendContainer-' + _unref(reportId),
        class: "legend-container"
      }, null, 8, _hoisted_2)
    ]),
    _: 1
  }, 8, ["report-id", "title", "data-empty", "loaded-data", "loading-error"]))
}
}

})